import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { Button as ButtonMemoized } from '../Button/Button.js';

var FastForwardIndicator = function FastForwardIndicator(_ref) {
  var direction = _ref.direction,
    onClick = _ref.onClick,
    fastForwardLabel = _ref.fastForwardLabel,
    fastBackwardLabel = _ref.fastBackwardLabel;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isHovered = _React$useState2[0],
    setIsHovered = _React$useState2[1];
  var onMouseEnter = React.useCallback(function () {
    setIsHovered(true);
  }, []);
  var onMouseLeave = React.useCallback(function () {
    setIsHovered(false);
  }, []);
  return /*#__PURE__*/React.createElement(ButtonMemoized, {
    variant: "icon",
    hierarchy: "tertiary",
    size: "s",
    onClick: onClick,
    leadingIcon: isHovered ? "line.arrow.dbl-".concat(direction) : 'fill.symbol.more',
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onFocus: onMouseEnter,
    onBlur: onMouseLeave,
    label: direction === 'left' ? fastBackwardLabel : fastForwardLabel
  });
};
var FastForwardIndicator$1 = /*#__PURE__*/React.memo(FastForwardIndicator);

export { FastForwardIndicator$1 as default };
//# sourceMappingURL=FastForwardIndicator.js.map
